module.exports = __webpack_public_path__ + "static/media/paraco_dila.994c7158.png";